<template>
  <div>
    {{ displayValue }}
  </div>
</template>

<script>
import { MenuTypes } from '@/models/Menu/Constants'

export default {
  name: 'AppMenuType',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayValue() {
      switch (this.value) {
        case MenuTypes.Geo:
          return 'ジオターゲティング'
        case MenuTypes.Newspaper:
          return '新聞購読率ターゲティング'
        case MenuTypes.Pta:
          return 'PTAターゲティング'
        case MenuTypes.Automobile:
          return '自動車ターゲティング'
        case MenuTypes.Mansion:
          return 'マンションターゲティング'
        case MenuTypes.GeoGenome:
          return 'GeoGenomeターゲティング'
        case MenuTypes.Railway:
          return '鉄道ターゲティング'
        case MenuTypes.Retargeting:
          return 'リターゲティング'
        case MenuTypes.CustomGeo:
          return 'カスタムジオターゲティング'
        case MenuTypes.Office:
          return 'オフィスターゲティング'
        case MenuTypes.Custom:
          return 'カスタムターゲティング'
        default:
          return ''
      }
    },
  },
}
</script>
